import React from 'react';

import { Col, Container, Row } from 'reactstrap';

import classnames from 'classnames';

import { useDate } from '@hsp/react-hooks';

import { useSidebarStore } from 'store/sidebar/store';

import { SessionTime, TokenTime } from './component';

const Footer = () => {
  const isOpen = useSidebarStore((state) => state.open);
  const { year } = useDate();

  return (
    <React.Fragment>
      <footer className={classnames('footer', { 'footer-shifted': isOpen })}>
        <Container fluid={true}>
          <Row>
            <Col sm={6}>{year} © HSP Direct.</Col>
            <Col sm={6}>
              <div className="d-flex justify-content-end">
                <SessionTime />
                <TokenTime />
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
